var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import AbstractEditable from './abstract';
var DateEditable = /** @class */ (function (_super) {
    __extends(DateEditable, _super);
    function DateEditable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DateEditable.prototype.render = function () {
        var _this = this;
        var self = this;
        var $input = jQuery(this.getElement().querySelector('[name=date]'));
        document.body.classList.add('ac-jqui');
        $input.prop('readonly', true).datepicker({
            dateFormat: 'yy-mm-dd',
            changeYear: true,
            firstDay: this._args.weekstart,
            showButtonPanel: true,
            onSelect: function () {
                if (!_this._args.showbuttons) {
                    self.save();
                }
            },
            beforeShow: function (input, inst) {
                setTimeout(function () {
                    var datepicker = inst.dpDiv.get(0);
                    datepicker.style.position = 'relative';
                    datepicker.style.left = 0;
                    datepicker.style.top = 0;
                    self.getElement().querySelector('.input__date').append(datepicker);
                }, 0);
            }
        }).on('click', function () {
            $input.prop('readonly', false);
        }).on('blur', function () {
            $input.prop('readonly', true);
        });
    };
    DateEditable.prototype.valueToInput = function (value) {
        var _this = this;
        if (!value) {
            return;
        }
        if (value.length === 8) {
            value = DateEditable.mapACFDateFormat(value);
        }
        setTimeout(function () {
            jQuery(_this.getElement().querySelector('[name=date]')).val(value).datepicker('show');
        }, 0);
    };
    DateEditable.prototype.getValue = function () {
        return this.getElement().querySelector('[name=date]').value;
    };
    DateEditable.prototype.getTemplate = function () {
        var input = this._template.form.input('date', '', { placeholder: 'yyyy-mm-dd', autocomplete: 'nope' }).outerHTML;
        return "\n\t\t\t" + input + "\n\t\t\t<div class=\"input__date\"></div>\n\t\t";
    };
    DateEditable.prototype._setDefaults = function () {
        this._defaults.weekstart = 1;
        this._defaults.type = 'date';
        this._defaults.showbuttons = true;
    };
    DateEditable.mapACFDateFormat = function (date) {
        date = [date.slice(0, 4), '-', date.slice(4)].join('');
        date = [date.slice(0, 7), '-', date.slice(7)].join('');
        return date;
    };
    return DateEditable;
}(AbstractEditable));
export default DateEditable;
